import { Spinner } from '@frontend/components/common';
import { LuCircleAlert } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { ItsmeQrAuthenticationFlowViewProps } from '../../hooks/useItsmeQrAuthenticationFlow';

export interface ItsmeQrAuthenticationContentProps extends ItsmeQrAuthenticationFlowViewProps {}

export const ItsmeQrAuthenticationContent = (props: ItsmeQrAuthenticationContentProps) => {
    if (props.error) {
        return (
            <div className='flex flex-col gap-8'>
                <p className='text-content-primary text-lg'>
                    <FormattedMessage
                        id='wizard.itsmeQrAuthentication.description'
                        defaultMessage='Scan the QR code with your itsme app to sign in securely.'
                        description='Description text explaining how to use the itsme QR authentication.'
                    />
                </p>

                <div className='border-status-danger flex items-start gap-3 rounded-lg border p-4'>
                    <div className='flex size-6 h-full items-center justify-center'>
                        <LuCircleAlert className='text-status-danger size-full' />
                    </div>
                    <p className='text-status-danger font-medium'>{props.error}</p>
                </div>
            </div>
        );
    }

    if (props.authenticating || props.authenticated) {
        return (
            <div className='flex flex-col gap-8'>
                <p className='text-content-primary text-lg'>
                    <FormattedMessage
                        id='wizard.itsmeQrAuthentication.description'
                        defaultMessage='Scan the QR code with your itsme app to sign in securely.'
                        description='Description text explaining how to use the itsme QR authentication.'
                    />
                </p>

                <div className='bg-background-surface border-border-default flex justify-center rounded-xl border p-8'>
                    <div className='flex aspect-square w-96 flex-col items-center justify-center gap-4'>
                        <p className='text-center'>
                            {props.authenticated ? (
                                <FormattedMessage
                                    id='wizard.itsmeQrAuthentication.authenticated'
                                    defaultMessage='You have been successfully authenticated. Please wait while we log you in.'
                                    description='Message shown when the user has been successfully authenticated via itsme.'
                                />
                            ) : (
                                <FormattedMessage
                                    id='wizard.itsmeQrAuthentication.authenticating'
                                    defaultMessage='Authenticating your identity, please wait...'
                                    description='Message shown when the itsme authentication is in progress.'
                                />
                            )}
                        </p>
                        <Spinner />
                    </div>
                </div>
            </div>
        );
    }

    if (props.qrCode) {
        return (
            <div className='flex flex-col gap-8'>
                <p className='text-content-primary text-lg'>
                    <FormattedMessage
                        id='wizard.itsmeQrAuthentication.description'
                        defaultMessage='Scan the QR code with your itsme app to sign in securely.'
                        description='Description text explaining how to use the itsme QR authentication.'
                    />
                </p>

                <div className='bg-background-surface border-border-default flex justify-center rounded-xl border p-8'>
                    {props.expired ? (
                        <div className='flex aspect-square w-96 flex-col items-center justify-center gap-4'>
                            <Spinner />
                            <p className='text-center'>
                                <FormattedMessage
                                    id='wizard.itsmeQrAuthentication.qrCodeExpired'
                                    defaultMessage='The QR code has expired. Please wait while we generate a new one.'
                                    description='Message shown when the itsme QR code has expired and a new one is being generated.'
                                />
                            </p>
                        </div>
                    ) : (
                        <img
                            src={`data:image/png;base64,${props.qrCode}`}
                            alt='itsme QR Code'
                            className='w-[80%]'
                        />
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    );
};
